import React from "react";
import { StackChart } from "./StackChart";
import LineChart from "./LineChart";
import PieChart from "./PieChart";
import SlotChart from "./SlotChart";
import BarChart from "./BarChart";

export { StackChart, LineChart, PieChart, SlotChart, BarChart };

export const chartTypeMap: Record<string, React.ComponentType<any>> = {
  stack: StackChart,
  line: LineChart,
  pie: PieChart,
  bar: BarChart,
  slot: SlotChart,
};